import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", {
    class: "demo-app",
    style: _normalizeStyle({
      '--background-color': _ctx.$store.state.BackgroundStatus.BackgroundColor,
      '--aColor': _ctx.$store.state.BackgroundStatus.ActiveTextColor,
      '--hover': _ctx.$store.state.BackgroundStatus.HoverColor,
      '--act-color': _ctx.$store.state.BackgroundStatus.TextColor
    })
  }, [_createVNode(_component_router_view)], 4);
}